import React, { FC, forwardRef, ReactElement } from 'react';
import styled from '@emotion/styled';
import { ArrowheadRightSmall } from '@blueprint/icons';
import { ContainerButton, ContainerLink, Label } from './CTA.styles';

type Props = {
    label: string;
    icon: ReactElement;
    iconAction?: ReactElement;
};

type ButtonProps = Props & React.ButtonHTMLAttributes<HTMLButtonElement>;
type LinkProps = Props & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const inner: FC<Props> = ({ label, icon, iconAction }: Props) => {
    return (
        <>
            {icon}
            <Label>{label}</Label>
            {iconAction || <ArrowheadRightSmall />}
        </>
    );
};

const CTAButtonComponent = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ label, icon, iconAction, ...rest }, ref) => {
        return (
            <ContainerButton {...rest} ref={ref}>
                {inner({ label, icon, iconAction })}
            </ContainerButton>
        );
    }
);

const CTALinkComponent = forwardRef<HTMLAnchorElement, LinkProps>(
    ({ label, icon, iconAction, ...rest }, ref) => {
        return (
            <ContainerLink {...rest} ref={ref}>
                {inner({ label, icon, iconAction })}
            </ContainerLink>
        );
    }
);

const CTAButton = styled(CTAButtonComponent)();
const CTALink = styled(CTALinkComponent)();

export { CTAButton, CTALink };
